import { t } from "i18next";
import { formatDate } from "../../../utils";

export const mapSupplierQuestionnairesSummaryData = (apiData, isForCurrentUser, currentUser, currentUserPermissions) => {
  if (apiData && apiData.length > 0) {
    return apiData
      .filter(questionnaire => {
        if (isForCurrentUser) {
          return questionnaire.assignee?.toLowerCase() === currentUser?.toLowerCase();
        } else {
          return questionnaire.assignee?.toLowerCase() !== currentUser?.toLowerCase();
        }
      })
      .map(questionnaire => {
      return {
        id: questionnaire.id,
        questionnaire: t(`supplierQuestionnaires.questionnaireTypes.${questionnaire.type}`, { defaultValue: "" }),
        period: questionnaire.period ? `${questionnaire.period.year} ${questionnaire.period.quarter}` : "",
        status: questionnaire.status,
        type: questionnaire.type,
        mappedStatus: questionnaire.status ?
          t(`questionnaireStatus.${questionnaire.status}`) : "",
        endDate: formatDate(questionnaire?.endDate ?? null, false)
      };
    });
  }
  return [];
};